<template>
  <div class="abs-poster" >


    <el-form-item v-if="$teras.evento.poster==1" :label="$teras.lang.datiabsPoster" prop="poster" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.poster"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <el-form-item label="Topic" v-if="(($teras.evento.poster==1 && $abs.row.poster==1 ) || $teras.evento.poster==2) && $teras.topicposter.length>0" prop="topicposter">
      <el-select v-model="$abs.row.topicposter" :placeholder="$teras.lang.scegliere_lista" style="width:100%">
          <el-option v-for="item in $teras.topicposter" :label="item.nome" :value="item.id" :key="item.id"></el-option>
      </el-select> 
    </el-form-item>

    <!-- PREMI FONDAZIONE  evento 136 -->
    <el-form-item v-if="$teras.evento.id==136 && $abs.row.poster==1" label="Partecipi al Premio della Fondazione?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI BINDING SITE -->


    <el-form-item v-if="$teras.evento.comunicazione==1" :label="$teras.lang.datiabsOrale" prop="comunicazione" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.comunicazione"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <el-form-item label="Topic" v-if="(($teras.evento.comunicazione==1 && $abs.row.comunicazione==1 ) || $teras.evento.comunicazione==2)  && $teras.topiccomunicazione.length>0" prop="topiccomunicazione">
      <el-select v-model="$abs.row.topiccomunicazione" style="width:100%">
              <el-option v-for="item in $teras.topiccomunicazione" :label="item.nome" :value="item.id" :key="item.id"></el-option>
          </el-select> 
    </el-form-item>


    
    <el-form-item v-if="$teras.evento.poster==3 && $abs.row.comunicazione=='0'" :label="$teras.lang.datiabsPoster" prop="poster" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.poster"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <el-form-item label="Topic" v-if="$teras.evento.poster==3 && $abs.row.poster==1 && $abs.row.comunicazione=='0' && $teras.topicposter.length>0" prop="topicposter">
      <el-select v-model="$abs.row.topicposter" :placeholder="$teras.lang.scegliere_lista" style="width:100%">
          <el-option v-for="item in $teras.topicposter" :label="item.nome" :value="item.id" :key="item.id"></el-option>
      </el-select> 
    </el-form-item>


    <el-form-item v-if="$teras.evento.posterdopocomunicazione==1 && $abs.row.comunicazione==1" :label="$teras.lang.datiabsPosterNoOrale" prop="posterdopocomunicazione" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.poster"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <el-form-item label="Topic " v-if="$teras.evento.posterdopocomunicazione==1 && $abs.row.comunicazione==1 && $abs.row.poster==1 && $teras.topicposter.length>0" prop="topicposter">
      <el-select v-model="$abs.row.topicposter" :placeholder="$teras.lang.scegliere_lista" style="width:100%">
          <el-option v-for="item in $teras.topicposter" :label="item.nome" :value="item.id" :key="item.id"></el-option>
      </el-select> 
    </el-form-item>


    <!-- PREMI BINDING SITE PER SIBioC evento 2 -->
    <el-form-item v-if="$abs.row.topicposter==11 && $abs.row.comunicazione==0" label="Desidera partecipare all'assegnazione del premio Binding Site?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI BINDING SITE -->

    <!-- PREMI BINDING SITE PER SIBioC evento 41 -->
    <el-form-item v-if="$abs.row.evento==41 && $abs.row.comunicazione==0" label="Desidera partecipare all'assegnazione del premio Binding Site?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI BINDING SITE -->

    <!-- PREMI SEBIA ITALIA SITE PER SIBioC evento 84 -->
    <el-form-item v-if="$abs.row.evento==84" label="Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI SEBIA ITALIA SITE -->

    <!-- PREMI SEBIA ITALIA SITE PER SIBioC evento 98 -->
    <el-form-item v-if="$abs.row.evento==98" label="Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - SECONDA EDIZIONE?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI SEBIA ITALIA SITE -->

    <!-- PREMI SEBIA ITALIA SITE PER SIBioC evento 131 in bvent 3652-->
    <el-form-item v-if="$abs.row.evento==131" label="Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - TERZA EDIZIONE?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI SEBIA ITALIA SITE -->

    <!-- PREMI SEBIA ITALIA SITE PER SIBioC evento 131 in bvent 4076-->
    <el-form-item v-if="$abs.row.evento==149" label="Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - QUARTA EDIZIONE?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI SEBIA ITALIA SITE -->

    <!-- PREMI SEBIA ITALIA SITE PER SIBioC evento 172 in bvent 4379-->
    <el-form-item v-if="$abs.row.evento==172" label="Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - QUINTA EDIZIONE?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI SEBIA ITALIA SITE -->

    <!-- PREMI PER SICP-SIVI evento 177 in bvent 4516-->
    <el-form-item v-if="$abs.row.evento==177" label="Desideri partecipare all'assegnazione dei Premi?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI -->

    

    <!-- PREMI PER SIGU evento 14 -->
    <el-form-item v-if="$teras.evento.id==14" label="Desidera concorrere ai premi previsti per il congresso?" prop="dmdaltro" class="yesno-label" >   
          <el-radio-group v-model="$abs.row.dmdaltro"  >
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>
    <!-- FINE PREMI PER SIGU -->


<!--
    <div v-if="$teras.evento.poster==1" class="formInfo"></div>
    <div class="row row-form" v-if="$teras.evento.poster==1">
        <div class="col s4 " style="">
              <el-radio-group v-model="$abs.row.poster" >
                <el-radio-button label="0">{{$teras.lang.no}}</el-radio-button>
                <el-radio-button label="1">{{$teras.lang.si}}</el-radio-button>
              </el-radio-group>
        </div>
        <div class="col s8" v-if="$abs.row.poster==1 && $teras.topicposter.length>0">
          <el-select v-model="$abs.row.topicposter" :placeholder="$teras.lang.scegliere_topic" style="width:100%">
              <el-option v-for="item in $teras.topicposter" :label="item.nome" :value="item.id"></el-option>
          </el-select>  
        </div>
    </div>
    

    <el-form-item label="Topic" v-if="$teras.evento.poster==2  && $abs.row.poster==1 && $teras.topicposter.length>0" prop="topicposter" >
      <el-select v-model="$abs.row.topicposter" :placeholder="$teras.lang.scegliere_topic" style="width:100%" >
          <el-option v-for="item in $teras.topicposter" :label="item.nome" :value="item.id"></el-option>
      </el-select> 
    </el-form-item>

-->

    

    
    

<!--
    <div v-if="$teras.evento.comunicazione==1" class="formInfo">Vuoi presentare l’abstract come comunicazione orale?</div>
    <div class="row row-form" v-if="$teras.evento.comunicazione==1" style="margin-bottom: 22px;">
        <div class="col s4 " style="">
              <el-radio-group v-model="$abs.row.comunicazione" >
                <el-radio-button :label="false">{{$teras.lang.no}}</el-radio-button>
                <el-radio-button :label="true">{{$teras.lang.si}}</el-radio-button>
              </el-radio-group>
              <el-switch
  v-model="$abs.row.comunicazione"
  :on-text="$teras.lang.si"
  :off-text="$teras.lang.no">
</el-switch>{{$abs.row.comunicazione}}
        </div>
        <div class="col s8" v-if="$abs.row.comunicazione==1 && $teras.topiccomunicazione.length>0">
          <el-select v-model="$abs.row.topiccomunicazione" style="width:100%">
              <el-option v-for="item in $teras.topiccomunicazione" :label="item.nome" :value="item.id"></el-option>
          </el-select>  
        </div>
    </div>
-->
    
    

<!--
    <div v-if="$teras.evento.posterdopocomunicazione==1" class="formInfo"></div>
    <div class="row row-form" v-if="$teras.evento.posterdopocomunicazione==1">
        <div class="col s4 " style="">
              <el-radio-group v-model="$abs.row.poster" >
                <el-radio-button label="0">{{$teras.lang.no}}</el-radio-button>
                <el-radio-button label="1">{{$teras.lang.si}}</el-radio-button>
              </el-radio-group>
              
        </div>
        <div class="col s8" v-if="$abs.row.poster==1 && $teras.topicposter.length>0">
          <el-select v-model="$abs.row.topicposter" :placeholder="$teras.lang.scegliere_lista" style="width:100%">
              <el-option v-for="item in $teras.topicposter" :label="item.nome" :value="item.id"></el-option>
          </el-select>  
        </div>
    </div>
-->

     
  

  </div>
</template>

<script>

export default {
  name: 'abs-primoautore',
  components: {
  },
  created () {
    console.log("Arrivo al abs-primoautore.vue");
    if(this.$teras.evento.poster==2)
      this.$abs.row.poster = '1'
      console.log(this.$abs.row)
    if(this.$teras.evento.comunicazione==2)
      this.$abs.row.comunicazione = 1
  },
  data() {
    return {
      options: {},
      autore:{
        id:-1,
        cognome: '',
        nome: '',
        affiliazione:''
      },
    }
  },
  computed:{
    annonascita: function(){
        var year = new Date().getFullYear()
        var arr = []
        for(var i = year-82; i <= year-18; i++) 
            arr.push(i)
        return arr
    }

  },
  methods: {
    affiliazione(id){
        for ( const affiliazione of this.$teras.affiliazioni){
            //console.log(affiliazione)
            if(affiliazione.id == id){
            return this.$teras.affiliazioni.indexOf(affiliazione)+1
            }
        }
        return $teras.lang.errore
      },
    onEnd(){
    },
    onEdit(autore){
      this.autore.id=autore.id
      this.autore.cognome=autore.cognome
      this.autore.nome=autore.nome
      this.autore.affiliazione=autore.affiliazione
    },
    delNow(){
      for ( const autore of this.$teras.autori){
        //console.log(autore)
        if(autore.id == this.autore.id){
          console.log(this.$teras.autori.indexOf(autore))
          this.$teras.autori.splice(this.$teras.autori.indexOf(autore),1)
          this.reset()
        }
      }
    },
    addNow(){
      this.autore.id = this.$teras.autori.length
      this.$teras.autori.push({id:this.autore.id,cognome:this.autore.cognome,nome:this.autore.nome,affiliazione:this.autore.affiliazione})
      this.reset()
    },
    editNow(){
      for (let autore of this.$teras.autori)
        if(autore.id == this.autore.id){
          autore.cognome=this.autore.cognome
          autore.nome=this.autore.nome
          autore.affiliazione=this.autore.affiliazione
        }
      this.reset()
    },
    reset(){
      this.autore.id=-1
      this.autore.cognome=''
      this.autore.nome=''
      this.autore.affiliazione = ''
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// Abs-poster.vue?120478ae